import { IconNames } from "../../../../Foundation/Icons";
import Button from "../../../Button";
import { ButtonTypes } from "../../../Button/interface";
import { ModalWithSliderProps } from "../../interface";
import Slider from "../../../Slider";
import styles from "./modalWithSlider.module.scss";
import { forwardRef, ForwardedRef, useRef, Children } from "react";

const LeftButton = forwardRef((props, ref: ForwardedRef<HTMLButtonElement>) => (
    <Button
        type={ButtonTypes.IconButton}
        label="Previous Video"
        name={IconNames.Left}
        background={true}
        ref={ref}
        {...props}
    />
));

const RightButton = forwardRef(
    (props, ref: ForwardedRef<HTMLButtonElement>) => (
        <Button
            type={ButtonTypes.IconButton}
            label="Next Video"
            name={IconNames.Right}
            background={true}
            ref={ref}
            {...props}
        />
    )
);

const ModalWithSlider = ({
    children,
    handleClose = () => null,
    onSlideChange = () => null,
    onSwiper = () => null,
    initialSlide = 0,
}: ModalWithSliderProps) => {
    const leftRef = useRef<HTMLButtonElement>(null);
    const rightRef = useRef<HTMLButtonElement>(null);

    const childrenCount = Children.count(children);
    const displayNavButtons = childrenCount > 1;

    return (
        <div className={styles.modalContent}>
            <div className={styles.closeButtonWrapper}>
                <Button
                    type={ButtonTypes.IconButton}
                    label="Close"
                    name={IconNames.Close}
                    background={false}
                    variant="dark"
                    onClick={handleClose}
                    size="32"
                />
            </div>
            {displayNavButtons && (
                <div className={styles.leftRightButtonWrapper}>
                    <LeftButton ref={leftRef} />
                    <RightButton ref={rightRef} />
                </div>
            )}

            <Slider
                centered={true}
                numSlides={1}
                initialSlide={initialSlide}
                onSlideChange={onSlideChange}
                onSwiper={onSwiper}
                customControls={{
                    rightButtonRef: rightRef,
                    leftButtonRef: leftRef,
                }}
            >
                {children}
            </Slider>
        </div>
    );
};
export default ModalWithSlider;
